import { EJoinOtaLegalShortStep } from '../../types/joinOtaLegalShort/step';
/**
 * возвращает шаги лендинга "Присоединение к онлайн бронированию для юр лиц"
 * @returns {EJoinOtaLegalShortStep[]} - массив шагов
 * фильтрация по Boolean нужна, чтобы в будущем не возникало ошибок при появлении опциональных шагов закрытых тогглами
 */
export function getSteps(): EJoinOtaLegalShortStep[] {
  return [EJoinOtaLegalShortStep.LegalData, EJoinOtaLegalShortStep.Insurance, EJoinOtaLegalShortStep.Success].filter(
    Boolean,
  ) as EJoinOtaLegalShortStep[];
}
